<script>
import { mapGetters } from 'vuex';

import clientMixins from 'utils/client-mixins';
import { privileges } from 'domains/base/_base-enum';

export default {
  mixins: [clientMixins],
  data: () => ({
    privileged: false,
  }),
  computed: mapGetters(['permissionRequestPayouts']),
  created() {
    if (this.hasPrivilege(privileges.SETTINGS)) {
      this.privileged = true;
      if (this.hasPrivilege(privileges.SETTINGS_PAYMENT) || this.permissionRequestPayouts) this.$store.dispatch('getPaymentInfo');
    } else {
      this.$router.replace('/');
    }
  },
};
</script>

<template lang='pug'>
.settings(v-if='privileged')
  router-view
</template>

<style>
@import '~import/index';
@import '~styles/index';

.settings {
  @include mq(mf-md) {
    padding: 0 4rem;
  }
}

.payouts {
  @extend %settings-container;
  max-width: 1400px;

  &__form-required {
    @extend %text-center;
    margin: 4rem 1rem;

    >h1 {
      margin-bottom: 3rem;
    }

    >h5 {
      margin-top: 3rem;
    }
  }

  &-settings {
    @extend %flex;
    @extend %flex--center;
    padding: 4rem 0;

    &__container {
      @include col(xs, 6);

      >.accordion {
        margin-bottom: 2rem;
      }
    }

    &__address {
      @include col(xs, 12);
      @include col(md, 8);

      @include mq(mf-md) {
        padding-right: 1rem;
      }
    }

    &__apt {
      @include col(xs, 12);
      @include col(md, 4);

      @include mq(mf-md) {
        padding-left: 1rem;
      }
    }

    &__address,
    &__apt {
      @extend %full-width;
      display: inline-block;
      vertical-align: top;
      padding-left: 0;
      padding-right: 0;
    }

    &__address {
      @include mq(mf-md) {
        padding-right: 1rem;
      }
    }

    &__apt {
      @include mq(mf-md) {
        padding-left: 1rem;
      }
    }
  }
}

.referrals {
  &__share {
    @extend %content-container;
    margin-bottom: 1rem;
    padding: 2rem;
  }

  &__heading {
    margin-bottom: 2rem;
  }
}
</style>